import {NgModule} from "@angular/core";
import {CdkVirtualScrollViewportPatchDirective} from "./cdk-virtual-scroll-viewport-patch.directive";
import {PinchZoomDirective} from "./pinch-zoom.directive";

@NgModule({
  declarations: [
    CdkVirtualScrollViewportPatchDirective,
    PinchZoomDirective,
  ],
  exports: [
    CdkVirtualScrollViewportPatchDirective,
    PinchZoomDirective,
  ]
})
export class DirectivesModule {
}
